import React, { useState } from 'react';
import { Button, Typography, Divider } from '@mui/material';
import Grid from '@mui/material/Grid2';
import callApi from '../common/APIClient';

function FileUpload() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState('');

  // Handle file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const [ocrText, setOcrText] = useState("");

  // Handle file upload to REST API
  const handleFileUpload = async () => {
    if (!selectedFile) {
      alert('Please select a file before uploading.');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    setIsUploading(true);
    setUploadStatus('Extracting...');

    try {
      const response = await callApi({
        url: "/ocr/",
        method: "POST",
        params: {}
      });
      
      setUploadStatus('OCR successful!');
      setOcrText(response.data.extracted_text);
      console.log('Server Response:', response.data);
    } catch (error) {
      setUploadStatus('Upload failed.');
      console.error('Upload error:', error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Grid container spacing={2}>
        <Grid size={12}>
            <Typography variant="h6">File Upload</Typography>
        </Grid>
        <Grid size={4}>
            {/* File input */}
            <Button variant="contained" component="label">
                Choose File
                <input type="file" hidden onChange={handleFileChange} />
            </Button>
        </Grid>
        <Grid size={8}>
            {selectedFile && (
                <Typography variant="body2" sx={{ marginTop: 2 }}>
                Selected file: {selectedFile.name}
                </Typography>
            )}
        </Grid>
        <Grid size={4}>
            {/* Upload Button */}
            <Button
                variant="contained"
                color="primary"
                onClick={handleFileUpload}
                disabled={isUploading || !selectedFile}
                sx={{ marginTop: 2 }}
            >
                Run OCR
            </Button>
        </Grid>
        <Grid size={8}>
            {/* Upload Status */}
            {uploadStatus && (
                <Typography variant="body2" sx={{ marginTop: 2 }}>
                {uploadStatus}
                </Typography>
            )}
        </Grid>
        <Grid size={12}><Divider></Divider></Grid>
        <Grid size={6}>
            
        </Grid>        
        <Grid size={6}>            
        </Grid>
        <Grid size={12}>
            <Typography variant="body1" sx={{ marginTop: 2, whiteSpace: 'pre-line' }}>
                {ocrText}
            </Typography>
        </Grid>
    </Grid>
  );
}

export default FileUpload;
